import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldHighlightService, FieldLocation } from '../../../../services';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-action-required',
  imports: [
    CommonModule,
    MatIcon,
  ],
  templateUrl: './action-required.component.html',
  styleUrl: './action-required.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionRequiredComponent { 
  highlightedField = inject(FieldHighlightService).highlightedField;

  protected FieldLocation = FieldLocation;
}
